import { render } from "./GoalModal.vue?vue&type=template&id=63e259ce&scoped=true"
import script from "./GoalModal.vue?vue&type=script&lang=js"
export * from "./GoalModal.vue?vue&type=script&lang=js"

import "./GoalModal.vue?vue&type=style&index=0&id=63e259ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e259ce"]])

export default __exports__